import { CheckCheck, FileText, Link2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { WA_MOCK } from "./WhatsAppMockChrome";

type WhatsAppAttachmentBubbleProps = {
  side: "customer" | "agent";
  kind: "pdf" | "link";
  caption?: string;
  fileName: string;
  fileMeta?: string;
  linkUrl?: string;
};

export function WhatsAppAttachmentBubble({
  side,
  kind,
  caption,
  fileName,
  fileMeta,
  linkUrl,
}: WhatsAppAttachmentBubbleProps) {
  const isAgent = side === "agent";

  return (
    <div className={cn("flex w-full", isAgent ? "justify-end" : "justify-start")}>
      <div className={cn("max-w-[92%]", isAgent ? "rounded-tr-none" : "rounded-tl-none")}>
        {caption ? (
          <div
            className={cn(
              "mb-0.5 rounded-lg px-2.5 py-1.5 text-[11px] leading-[1.45] shadow-sm",
              isAgent ? "rounded-tr-none" : "rounded-tl-none",
            )}
            style={{
              backgroundColor: isAgent ? WA_MOCK.outgoing : WA_MOCK.incoming,
              color: WA_MOCK.text,
            }}
          >
            <p>{caption}</p>
          </div>
        ) : null}
        <div
          className={cn(
            "overflow-hidden rounded-lg bg-white shadow-sm ring-1 ring-black/[0.04]",
            isAgent ? "rounded-tr-none" : "rounded-tl-none",
          )}
        >
          <div className="flex min-w-[148px] max-w-[200px]">
            <div
              className={cn(
                "flex w-11 shrink-0 items-center justify-center",
                kind === "pdf" ? "bg-[#f0f2f5]" : "bg-[#e7f3ff]",
              )}
            >
              {kind === "pdf" ? (
                <div className="flex flex-col items-center">
                  <FileText className="h-5 w-5 text-red-600" strokeWidth={1.75} aria-hidden />
                  <span className="mt-0.5 text-[7px] font-bold uppercase text-red-600">PDF</span>
                </div>
              ) : (
                <Link2 className="h-5 w-5 text-blue-600" strokeWidth={1.75} aria-hidden />
              )}
            </div>
            <div className="min-w-0 flex-1 border-l border-black/[0.06] px-2 py-1.5">
              <p className="truncate text-[10px] font-semibold text-[#111B21]">{fileName}</p>
              <p className="truncate text-[9px] text-[#667781]">
                {kind === "pdf" ? fileMeta ?? "Documento" : linkUrl ?? fileMeta}
              </p>
            </div>
          </div>
        </div>
        {isAgent ? (
          <div className="mt-0.5 flex justify-end pr-0.5">
            <CheckCheck className="h-3 w-3" style={{ color: WA_MOCK.tick }} aria-hidden />
          </div>
        ) : null}
      </div>
    </div>
  );
}
